import { render } from "./ColorCustomizer.vue?vue&type=template&id=d1555c1e"
import script from "./ColorCustomizer.vue?vue&type=script&lang=js"
export * from "./ColorCustomizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__